import { Effect, Layer } from "effect";
import type { Scope } from "effect";
import { AtomRegistry } from "effect/unstable/reactivity";
import { WorkerBindingsApi } from "../../api/worker-bindings/service.ts";
import { QueryWork } from "../../state/query-work.ts";
import { makeSessionOwner } from "../../state/session-owner.ts";
import { makeCatalogSession } from "../catalog/operations.ts";
import { WorkerBindingsSessions } from "./service.ts";

export const WorkerBindingsSessionsLive = (root: Scope.Scope) => Layer.effect(WorkerBindingsSessions, Effect.gen(function* () {
  const api = yield* WorkerBindingsApi, registry = yield* AtomRegistry.AtomRegistry, queries = yield* QueryWork;
  const sessions = yield* makeSessionOwner(root);
  return WorkerBindingsSessions.of({ open: sessions.open(makeCatalogSession(root, api.load).pipe(
    Effect.provideService(AtomRegistry.AtomRegistry, registry), Effect.provideService(QueryWork, queries)
  )) });
}));
